module.exports = __webpack_public_path__ + "static/media/redtie_logo.63bfdc08.png";